import { inputBaseClasses, outlinedInputClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { isTouchEnabled } from '../../../../../../../../../../../../Theme';

const useSelloutDistributionQuantityInputStyles = makeStyles()((theme) => ({
  textField: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',

    [`& .${inputBaseClasses.root}`]: {
      width: '56px',
      height: '26px',
      borderRadius: '5px',
      boxSizing: 'border-box',
      justifyContent: 'center',
    },

    [`& .${inputBaseClasses.input}`]: {
      width: '100%',
      height: '26px',
      boxSizing: 'border-box',
      textAlign: 'center',
      padding: 0,
    },

    [`& .${inputBaseClasses.root}.${inputBaseClasses.disabled}`]: {
      backgroundColor: isTouchEnabled ? undefined : theme.palette.grey[50],
    },

    [`& .${outlinedInputClasses.notchedOutline}`]: {
      [theme.breakpoints.up('sm')]: {
        border: isTouchEnabled ? 'none' : undefined,
      },
      [theme.breakpoints.down('sm')]: {
        border: 'none',
      },
    },
  },
}));

export default useSelloutDistributionQuantityInputStyles;
